import * as ambassadorWixEcomV1DeliveryProfile from './ecom-v1-delivery-profile-delivery-profile.http.js';
import * as ambassadorWixEcomV1DeliveryProfileTypes from './ecom-v1-delivery-profile-delivery-profile.types.js';
import * as ambassadorWixEcomV1DeliveryProfileUniversalTypes from './ecom-v1-delivery-profile-delivery-profile.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createDeliveryProfile(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.CreateDeliveryProfileRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.CreateDeliveryProfileRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.CreateDeliveryProfileResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.CreateDeliveryProfileResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.createDeliveryProfile(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/delivery-profiles',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDeliveryProfile(): __PublicMethodMetaInfo<
  'GET',
  { deliveryProfileId: string },
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.GetDeliveryProfileRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.GetDeliveryProfileRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.GetDeliveryProfileResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.GetDeliveryProfileResponse
> {
  const payload = { deliveryProfileId: ':deliveryProfileId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.getDeliveryProfile(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/delivery-profiles/{deliveryProfileId}',
    pathParams: { deliveryProfileId: 'deliveryProfileId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateDeliveryProfile(): __PublicMethodMetaInfo<
  'PATCH',
  { deliveryProfileId: string },
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.UpdateDeliveryProfileRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.UpdateDeliveryProfileRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.UpdateDeliveryProfileResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.UpdateDeliveryProfileResponse
> {
  const payload = { deliveryProfile: { id: ':deliveryProfileId' } } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.updateDeliveryProfile(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/delivery-profiles/{deliveryProfile.id}',
    pathParams: { deliveryProfileId: 'deliveryProfileId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteDeliveryProfile(): __PublicMethodMetaInfo<
  'DELETE',
  { deliveryProfileId: string },
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.DeleteDeliveryProfileRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.DeleteDeliveryProfileRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.DeleteDeliveryProfileResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.DeleteDeliveryProfileResponse
> {
  const payload = { deliveryProfileId: ':deliveryProfileId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.deleteDeliveryProfile(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/delivery-profiles/{deliveryProfileId}',
    pathParams: { deliveryProfileId: 'deliveryProfileId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryDeliveryProfiles(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.QueryDeliveryProfilesRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.QueryDeliveryProfilesRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.QueryDeliveryProfilesResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.QueryDeliveryProfilesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.queryDeliveryProfiles(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/delivery-profiles/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addDeliveryRegion(): __PublicMethodMetaInfo<
  'POST',
  { deliveryProfileId: string },
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.AddDeliveryRegionRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.AddDeliveryRegionRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.AddDeliveryRegionResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.AddDeliveryRegionResponse
> {
  const payload = { deliveryProfileId: ':deliveryProfileId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.addDeliveryRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/delivery-profiles/{deliveryProfileId}/delivery-region',
    pathParams: { deliveryProfileId: 'deliveryProfileId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateDeliveryRegion(): __PublicMethodMetaInfo<
  'PATCH',
  { deliveryProfileId: string; deliveryRegionId: string },
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.UpdateDeliveryRegionRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.UpdateDeliveryRegionRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.UpdateDeliveryRegionResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.UpdateDeliveryRegionResponse
> {
  const payload = {
    deliveryProfileId: ':deliveryProfileId',
    deliveryRegion: { id: ':deliveryRegionId' },
  } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.updateDeliveryRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/delivery-profiles/{deliveryProfileId}/delivery-region/{deliveryRegion.id}',
    pathParams: {
      deliveryProfileId: 'deliveryProfileId',
      deliveryRegionId: 'deliveryRegionId',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDeliveryProfileByDeliveryRegionId(): __PublicMethodMetaInfo<
  'GET',
  { deliveryRegionId: string },
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.GetDeliveryProfileByDeliveryRegionIdRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.GetDeliveryProfileByDeliveryRegionIdRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.GetDeliveryProfileByDeliveryRegionIdResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.GetDeliveryProfileByDeliveryRegionIdResponse
> {
  const payload = { deliveryRegionId: ':deliveryRegionId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.getDeliveryProfileByDeliveryRegionId(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/delivery-profiles/delivery-regions/{deliveryRegionId}',
    pathParams: { deliveryRegionId: 'deliveryRegionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeDeliveryRegion(): __PublicMethodMetaInfo<
  'DELETE',
  { deliveryProfileId: string; deliveryRegionId: string },
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.RemoveDeliveryRegionRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.RemoveDeliveryRegionRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.RemoveDeliveryRegionResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.RemoveDeliveryRegionResponse
> {
  const payload = {
    deliveryProfileId: ':deliveryProfileId',
    deliveryRegionId: ':deliveryRegionId',
  } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.removeDeliveryRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/delivery-profiles/{deliveryProfileId}/delivery-region/{deliveryRegionId}',
    pathParams: {
      deliveryProfileId: 'deliveryProfileId',
      deliveryRegionId: 'deliveryRegionId',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addDeliveryCarrier(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.AddDeliveryCarrierRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.AddDeliveryCarrierRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.AddDeliveryCarrierResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.AddDeliveryCarrierResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.addDeliveryCarrier(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/delivery-profiles/add-delivery-carrier',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeDeliveryCarrier(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.RemoveDeliveryCarrierRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.RemoveDeliveryCarrierRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.RemoveDeliveryCarrierResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.RemoveDeliveryCarrierResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.removeDeliveryCarrier(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/delivery-profiles/remove-delivery-carrier',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateDeliveryCarrier(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.UpdateDeliveryCarrierRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.UpdateDeliveryCarrierRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.UpdateDeliveryCarrierResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.UpdateDeliveryCarrierResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.updateDeliveryCarrier(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/delivery-profiles/update-delivery-carrier',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listInstalledDeliveryCarriers(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.ListInstalledDeliveryCarriersRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.ListInstalledDeliveryCarriersRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.ListInstalledDeliveryCarriersResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.ListInstalledDeliveryCarriersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.listInstalledDeliveryCarriers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/delivery-profiles/installed-carriers',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDeliveryDestinationProperties(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.GetDeliveryDestinationPropertiesRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.GetDeliveryDestinationPropertiesRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.GetDeliveryDestinationPropertiesResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.GetDeliveryDestinationPropertiesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.getDeliveryDestinationProperties(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/delivery-profiles/delivery-destination-properties',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDeliveryCarriers(): __PublicMethodMetaInfo<
  'POST',
  { deliveryProfileId: string },
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.ListDeliveryCarriersRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.ListDeliveryCarriersRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.ListDeliveryCarriersResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.ListDeliveryCarriersResponse
> {
  const payload = { deliveryProfileId: ':deliveryProfileId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.listDeliveryCarriers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/delivery-profiles/{deliveryProfileId}/delivery-carriers',
    pathParams: { deliveryProfileId: 'deliveryProfileId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCarrierSettings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.UpdateCarrierSettingsRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.UpdateCarrierSettingsRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.UpdateCarrierSettingsResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.UpdateCarrierSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.updateCarrierSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/delivery-carriers/update-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setDeliveryCarrierActiveStatus(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.SetDeliveryCarrierActiveStatusRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.SetDeliveryCarrierActiveStatusRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.SetDeliveryCarrierActiveStatusResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.SetDeliveryCarrierActiveStatusResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.setDeliveryCarrierActiveStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/delivery-profiles/delivery-carriers/set-active-status',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixEcomV1DeliveryProfileTypes.UpdateExtendedFieldsRequest,
  ambassadorWixEcomV1DeliveryProfileUniversalTypes.UpdateExtendedFieldsResponse,
  ambassadorWixEcomV1DeliveryProfileTypes.UpdateExtendedFieldsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DeliveryProfile.updateExtendedFields(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/delivery-profiles/{id}/update-extended-fields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  DeliveryProfile as DeliveryProfileOriginal,
  DeliveryRegion as DeliveryRegionOriginal,
  DeliveryCarrier as DeliveryCarrierOriginal,
  BackupRate as BackupRateOriginal,
  AdditionalCharge as AdditionalChargeOriginal,
  Destination as DestinationOriginal,
  CreatedBy as CreatedByOriginal,
  CreatedByIdOneOf as CreatedByIdOneOfOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  DeliveryRegionAdded as DeliveryRegionAddedOriginal,
  DeliveryRegionRemoved as DeliveryRegionRemovedOriginal,
  DeliveryRegionUpdated as DeliveryRegionUpdatedOriginal,
  CreateDeliveryProfileRequest as CreateDeliveryProfileRequestOriginal,
  CreateDeliveryProfileResponse as CreateDeliveryProfileResponseOriginal,
  GetDeliveryProfileRequest as GetDeliveryProfileRequestOriginal,
  GetDeliveryProfileResponse as GetDeliveryProfileResponseOriginal,
  UpdateDeliveryProfileRequest as UpdateDeliveryProfileRequestOriginal,
  UpdateDeliveryProfileResponse as UpdateDeliveryProfileResponseOriginal,
  DeleteDeliveryProfileRequest as DeleteDeliveryProfileRequestOriginal,
  DeleteDeliveryProfileResponse as DeleteDeliveryProfileResponseOriginal,
  DeleteDefaultDeliveryProfileRequest as DeleteDefaultDeliveryProfileRequestOriginal,
  DeleteDefaultDeliveryProfileResponse as DeleteDefaultDeliveryProfileResponseOriginal,
  QueryDeliveryProfilesRequest as QueryDeliveryProfilesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryDeliveryProfilesResponse as QueryDeliveryProfilesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  AddDeliveryRegionRequest as AddDeliveryRegionRequestOriginal,
  AddDeliveryRegionResponse as AddDeliveryRegionResponseOriginal,
  UpdateDeliveryRegionRequest as UpdateDeliveryRegionRequestOriginal,
  UpdateDeliveryRegionResponse as UpdateDeliveryRegionResponseOriginal,
  GetDeliveryProfileByDeliveryRegionIdRequest as GetDeliveryProfileByDeliveryRegionIdRequestOriginal,
  GetDeliveryProfileByDeliveryRegionIdResponse as GetDeliveryProfileByDeliveryRegionIdResponseOriginal,
  RemoveDeliveryRegionRequest as RemoveDeliveryRegionRequestOriginal,
  RemoveDeliveryRegionResponse as RemoveDeliveryRegionResponseOriginal,
  AddDeliveryCarrierRequest as AddDeliveryCarrierRequestOriginal,
  AddDeliveryCarrierResponse as AddDeliveryCarrierResponseOriginal,
  RemoveDeliveryCarrierRequest as RemoveDeliveryCarrierRequestOriginal,
  RemoveDeliveryCarrierResponse as RemoveDeliveryCarrierResponseOriginal,
  UpdateDeliveryCarrierRequest as UpdateDeliveryCarrierRequestOriginal,
  UpdateDeliveryCarrierResponse as UpdateDeliveryCarrierResponseOriginal,
  ListInstalledDeliveryCarriersRequest as ListInstalledDeliveryCarriersRequestOriginal,
  ListInstalledDeliveryCarriersResponse as ListInstalledDeliveryCarriersResponseOriginal,
  InstalledDeliveryCarrier as InstalledDeliveryCarrierOriginal,
  ListDeliveryDestinationsRequest as ListDeliveryDestinationsRequestOriginal,
  ListDeliveryDestinationsResponse as ListDeliveryDestinationsResponseOriginal,
  DestinationScope as DestinationScopeOriginal,
  DestinationScopeWithLiterals as DestinationScopeWithLiteralsOriginal,
  RequiredZipcodeRequest as RequiredZipcodeRequestOriginal,
  RequiredZipcodeResponse as RequiredZipcodeResponseOriginal,
  GetDeliveryDestinationPropertiesRequest as GetDeliveryDestinationPropertiesRequestOriginal,
  GetDeliveryDestinationPropertiesResponse as GetDeliveryDestinationPropertiesResponseOriginal,
  DeliveryDestinationProperties as DeliveryDestinationPropertiesOriginal,
  CountryDeliveryProperties as CountryDeliveryPropertiesOriginal,
  SubdivisionDeliveryProperties as SubdivisionDeliveryPropertiesOriginal,
  ListDeliveryCarriersRequest as ListDeliveryCarriersRequestOriginal,
  ListDeliveryCarriersResponse as ListDeliveryCarriersResponseOriginal,
  ListDeliveryCarriersResult as ListDeliveryCarriersResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  DeliveryCarrierDetails as DeliveryCarrierDetailsOriginal,
  DeliveryCarrierRegionalSettings as DeliveryCarrierRegionalSettingsOriginal,
  DashboardTable as DashboardTableOriginal,
  Column as ColumnOriginal,
  Row as RowOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  UpdateCarrierSettingsRequest as UpdateCarrierSettingsRequestOriginal,
  UpdateCarrierSettingsResponse as UpdateCarrierSettingsResponseOriginal,
  SetDeliveryCarrierActiveStatusRequest as SetDeliveryCarrierActiveStatusRequestOriginal,
  SetDeliveryCarrierActiveStatusResponse as SetDeliveryCarrierActiveStatusResponseOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateDeliveryProfileApplicationErrors as CreateDeliveryProfileApplicationErrorsOriginal,
  UpdateDeliveryProfileApplicationErrors as UpdateDeliveryProfileApplicationErrorsOriginal,
  AddDeliveryRegionApplicationErrors as AddDeliveryRegionApplicationErrorsOriginal,
  AddDeliveryRegionValidationErrors as AddDeliveryRegionValidationErrorsOriginal,
  UpdateDeliveryRegionApplicationErrors as UpdateDeliveryRegionApplicationErrorsOriginal,
  UpdateDeliveryRegionValidationErrors as UpdateDeliveryRegionValidationErrorsOriginal,
  GetDeliveryProfileByDeliveryRegionIdApplicationErrors as GetDeliveryProfileByDeliveryRegionIdApplicationErrorsOriginal,
  RemoveDeliveryRegionApplicationErrors as RemoveDeliveryRegionApplicationErrorsOriginal,
  AddDeliveryCarrierApplicationErrors as AddDeliveryCarrierApplicationErrorsOriginal,
  AddDeliveryCarrierValidationErrors as AddDeliveryCarrierValidationErrorsOriginal,
  RemoveDeliveryCarrierApplicationErrors as RemoveDeliveryCarrierApplicationErrorsOriginal,
  UpdateDeliveryCarrierApplicationErrors as UpdateDeliveryCarrierApplicationErrorsOriginal,
  ListDeliveryCarriersApplicationErrors as ListDeliveryCarriersApplicationErrorsOriginal,
  UpdateCarrierSettingsApplicationErrors as UpdateCarrierSettingsApplicationErrorsOriginal,
  SetDeliveryCarrierActiveStatusApplicationErrors as SetDeliveryCarrierActiveStatusApplicationErrorsOriginal,
} from './ecom-v1-delivery-profile-delivery-profile.types.js';
